// extracted by mini-css-extract-plugin
export default {"root":"FallbackPage_root__70rYa","content":"FallbackPage_content__2iEOF"};